import React from "react";
import PropTypes from "prop-types";
import Background from "../../../assets/img/new-logo-4-bg.png";
import {
  fetchMedicalRecords,
  getDeletable,
  updatePrintMRecord,
  fetchBreederDeliveryRecords,
  fetchBreederDeliveryRecordsByBreederId,
  fetchWaybillsForAllPets,
  updateMedicalRecord,
  boostWooStoreProfile,
  updateVideoCallStatus,
  updateWooPageStatus,
  petPinToTop,
  fetchMedicalRecordsByAge,
} from "./../../../actions/medicalRecords";
import { fetchBreeders, fetchBreedCategory } from "../../../actions/breeders";
import { fetchConfig } from "../../../actions/configuration";
import { fetchAnimalTypes } from "../../../actions/addAnimalType";
import { fetchRegTypes } from "../../../actions/regType";
import { getNotificationsByMedicalRecord } from "../../../actions/subscribeToPet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import NewMRecordForm from "../add";
import AvatarEditor from "react-avatar-editor";
import history from "../../../history.js";
import moment from "moment";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import "react-select/dist/react-select.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import MRecordPDF from "../../../components/mRecordPdf/mRecordPdf";
import DoPdf from "../../../components/doPdf/doPdf";
import CollerInsert from "../../../components/collarInsert/collarInsert";
import copy from 'copy-to-clipboard';
import DatePicker from "react-datepicker";
import 'react-dates/initialize';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import Responsive from "react-responsive";
import config from '../../../config';
import _ from 'lodash';
import Store from "../../../store";
import { Activity } from '../../../components/activity';
import Switch from "react-switch";
import { changeDateFormat } from '../../../utils/helper';
import ChangeArrivalDate from "../../../components/dataModal/changeArrivalDate";
import Coupon from "../coupon/list";

const $ = window.$;
const { SearchBar } = Search;

const genderOptions = {
  0: "male",
  1: "female"
};

const cbOptions = {
  0: "yes",
  1: "no"
};

const statusOptions = {
  0: "Available",
  1: "Draft",
  2: "Sold"
};
const petAvailabilityStatus = {
  available:"available",
  sold:"sold"
};
var toaOptions = {};
var rtOptions = {};
var tableHeaderColumnData = [];
var _self;

function normalToPascal(s) {
  return s.replace(/\w+/g,
    function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
}

function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    return [match[2], '-', match[3], '-', match[4]].join('')
  }
  return ""
}

const orientation = window.matchMedia("(max-width: 700px)").matches ? 'vertical' : 'horizontal'

const soldReasonValues = [
  {
    key: "sold-by-the-breeder",
    value: "Sold by the Breeder",
    notify: true
  },
  {
    key: "on-medical-treatment",
    value: "On Medical Treatment",
    notify: false
  },
  {
    key: "financing",
    value: "Financing",
    notify: false
  },
  {
    key: "on-hold",
    value: "On Hold",
    notify: false
  }
];

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  wooPageStatusOptions = {
    Public: "public",
    Finance: "finance",
    Private: "private"
  };

  wooPagePuppyStatusOptions = {
    Sold: "sold",
    Available: "available"
  }

  state = {
    openNew: false,
    confirmDelete: false,
    contentData: [],
    cdAvailable: [],
    cdDraft: [],
    cdSold: [],
    cdDeleted: [],
    selected: [],
    loadingDelete: false,
    deleteMRId: null,
    selectedTab: "Available",
    clickedId: "",
    clickedIdDoPdf: "",
    type: "shop",
    current_row: null,
    insta_post: false,
    dataBreederDelivery: [],
    startDate: null,
    endDate: null,
    sDate: null,
    eDate: null,
    loadingBd: false,
    focusedInput: null,
    focusedInputCI: null,
    focusedInputCIWaybill: null,
    clickedIdCollarInsert: null,
    breeders: [],
    BreederId: null,
    url_build: "?",
    envelope: false,
    waybill: false,
    medical_record: false,
    price: "",
    editMedicalRecord : null,
    isPriceEdit: false,
    priceError: false,
    arrivalDate: moment().toDate(),
    puppyBirthDate: null,
    arrivalDateError: false,
    isArrivalDateEdit: false,
    validateArrivalDate: true,
    isArrivalDateValid: true,
    petAgeOnArrival: null,
    arrivalDateValidationMessage: 'Arrival date should be 8 weeks greater than the selected "Date of Birth"',
    pdfOldVersion: false,
    boostProfileMRId: '',
    boostProfilePetId: '',
    isBoostProfileLoading: false,
    notifySubscribers: false,
    showNotify: false,
    video_call_status: false,
    loadingMedicalRecords: true,
    selectedWooPageStatusOption: this.wooPageStatusOptions.Public,
    selectedWooPagePuppyStatusOption: this.wooPagePuppyStatusOptions.Available,
    selectedMedicalRecord:null,
    loadingWooPageStatus: false,

    soldReason: null,
    customFormNotValid: false,
    loadingInfo: false,
    availableSubscribers : [],
    namePrompt : '',
    descriptionPrompt : '',
    openAiSuggestedPetsNames:[],
    openAiPersonalityDescription:'',
    isPinToTop: false,
    loadingPinToTop: false,
  };

  tableHeaderColumnData = [
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
      style: { "overflowX": "visible" }
    },

    {
      dataField: "pet_id",
      text: "Pet ID",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span className="m-topbar__userpic">
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.avatar_path +
                "/" +
                row.avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
              <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id }/${row.id}`}
                target="_blank"  
                style={{ color:"#ffff"}}      
               >
                <span className="m-badge m-badge--info mx-auto my-0 px-2">
                  <strong>{cell}</strong>
                </span>
               </a>        
          </span>
        );
      }
    },
    {
      dataField: "visibility_status",
      text: "Status",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
          { row.woo_pet_availability === petAvailabilityStatus.available ?
          <div>
          <span
            className={
              "m-badge mx-auto my-0 px-2 " +
              (row.status === "Available"
                ? "m-badge--success"
                : row.status === "Sold"
                  ? "m-badge--danger mb-2"
                  : " m-badge--wide")
            }
          >
            <strong>{row.status}</strong>         
          </span> 
          <br/>
            <span>
              {row.Contract != null ? <NavLink style={{ 
                  whiteSpace: "nowrap",
                  width: "70px", 
                  overflow: "hidden",
                  textOverflow: "ellipsis",
              }}
                    target="_blank"
                    to={`/contracts/${row.Contract.id}`}
                    className="m-badge mx-auto my-0 px-2 m-badge--success"
                    title="View Contract"
                  >
                    {row.Contract.Customer ? row.Contract.Customer.firstname: ''}
                  </NavLink> : ""}  
                </span>   
            </div>
            :<div>
            {row.Contract != null ?  
              <div>
              <span  className="m-badge mx-auto my-0 px-2 m-badge--danger mb-2">
                <strong>Sold</strong>
              </span>
              <br/>
              <span>
                <NavLink style={{ 
                  whiteSpace: "nowrap",
                  width: "70px", 
                   overflow: "hidden",
                  textOverflow: "ellipsis",
                 }}
                  target="_blank"
                  to={`/contracts/${row.Contract.id}`}
                  className="m-badge mx-auto my-0 px-2 m-badge--success"
                  title="View Contract"
                >                   
                  {row.Contract.Customer ? row.Contract.Customer.firstname: ''}
                </NavLink>   
              </span>               
            </div>
            :<div>       
              {row.sold_reason ?
              <span className="m-badge mx-auto my-0 px-2 m-badge--danger mb-2">
                <strong>{row.sold_reason}</strong> 
              </span>:<span  className="m-badge mx-auto my-0 px-2 m-badge--danger mb-2">
                <strong>Sold</strong> 
              </span>              
              } <br/>
              <span className="m-badge mx-auto my-0 px-1 m-badge--warning">
                <strong>No Contract</strong> 
              </span>       
            </div>
            }                  
            </div>}  
          </div>
        );
      }
    },
    {
      dataField: "breed_type",
      text: "Breed",
      sort: true
    },
    {
      dataField: "sex",
      text: "Gender",
      sort: true,
      formatter: cell => cell
    },
    {
      dataField: "price",
      text: "Price",
      sort: true,   
      formatter: (cell,row) => {return <a  onClick={(e)=>{this.openPriceEditModal(e,row)}} style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600" }}>{cell}</a> } 
    },
    {
      dataField: "pet_name",
      text: "Name",
      sort: true,   
      formatter: (cell,row) => {return <strong>{cell}</strong> } 
    },
    {
      dataField : "web_visibility",
      text: "Web Visibility",
      formatter: (cell, row) => { return (         
 
           row.mc_status === 'complete' && ! row.Contract &&  row.woo_pet ?
             <div className="row justify-content-center">
               <div className="col-xs-12">
                 <a
                 onClick={(e)=> this.openStatusChangeModal(e,row)}
                 style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600", }}
                 >
                 <div className="row justify-content-start">
                   <span>
                     <i className="la la-edit"></i>
                   </span> 
                 </div>
                 <div className="row justify-content-start">
                  <span className="m-badge my-0 px-2 m-badge--warning">
                   { row.woo_page_status === this.wooPageStatusOptions.Public ? `Visible` : row.woo_page_status === this.wooPageStatusOptions.Finance ? `Private` : row.woo_page_status === this.wooPageStatusOptions.Private ? `Hidden` : "None"}
                     
             
                   </span>  
                 </div>         
                 <div className="row justify-content-start">
                   <span
                     className={" m-badge mt-1 px-2 " +
                       (row.woo_pet_availability  ===  this.wooPagePuppyStatusOptions.Available 
                         ? "m-badge--success"                           
                         : "m-badge--danger mb-2"
                       )}
                   >
                     {row.woo_pet_availability  ===  this.wooPagePuppyStatusOptions.Available ? "Available" : "Sold"}                    
                   </span> 
                 </div>          
                 </a>
               </div>
             </div>
             : <span><strong>Unlisted </strong></span>    
       );       
     }
     },
    {
      dataField: "color_markings",
      text: "Color",
      sort: true
    },
    {
      dataField: "date_of_birth",
      text: "Date Of Birth",
      formatter: cell => moment(new Date(cell.replace(/-/g, "/"))).format("MM-DD-YYYY"),
      sort: true,
      sortFunc : (a,b,order) => { return this.customDateSort(a,b,order) }
    },
    {
      dataField: "arrival_date",
      text: "Arrival Date",     
      formatter: (cell, row) => {  
        let date = changeDateFormat(cell, "MM-DD-YYYY", "MM-DD-YYYY");
        return <a onClick={(e) => {this.openArrivalDateEditModal(e, row)}} style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600" }}>{date}</a> 
      },
      sort: true,
      sortFunc : (a,b,order) => { return this.customDateSort(a,b,order) }
    },
    {
      dataField: "SubscribeToPets",
      text: "SUBS",
      sort: true,
      formatter: cell => {
        return <span>{cell.length}</span>
      },
      headerStyle: (column, colIndex) => {
        return { width: '60px' };
      }
    },
   {
      dataField: "breeder",
      text: "Breeder/ Phone/ USDA",
      sort: true,
      formatter:(cell, row) =>{
        return(
         <div>
         <span>{row.breeder}</span>
         { row.breeder_phone &&
         <>
         <br/>      
         <a href={`tel:${row.breeder_phone}`} className="hyperlink-phone-number">{row.breeder_phone}</a>         
         </>
         }
         { row.usda_no &&
         <>
         <br/>
         <span>{row.usda_no}</span> 
         </> 
         }

         </div>
        );
      }
    },  
    {
      dataField: "pinToTopStatus",
      text: "Pin To Top Status",
      sort: true,
      formatter : (cell,row) => {
        return (
          <div>
          {row.mc_status !== "draft" && row.mc_status === "complete" ? (
              <>
                {!row.Contract ? (
                  <>
                    {row.woo_pet ? (
                      <div>
                        <Switch
                          onChange={(e) => {
                            this.pinToTopUpdateQueue(e, row);
                          }}
                          key={row.id}
                          checked={row.pinToTopStatus}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          onColor={"#34bfa3"}
                          offColor={"#f4516c"}
                        />                    
                      </div>
                    ) :
                    (
                      <div className="m-widget4__ext">
                        <div className="text-sm"><strong>Unavailable</strong></div>
                      </div>
                    )}
                  </>
                ): (
                  <div className="m-widget4__ext">
                    <div className="text-sm"><strong>Unavailable</strong></div>
                  </div>
                )}
              </>
            ) : 
            <div className="m-widget4__ext">
             <div className="text-sm"><strong>Unavailable</strong></div>
           </div>}
          </div>
        )
      }
    },
    {
      dataField: "customer",
      hidden : true
    },
    {
      dataField: "video_call_status",
      text: "Arrange a Call",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div>
          {row.mc_status !== "draft" && row.mc_status === "complete" ? (
              <>
                {!row.Contract ? (
                  <>
                    {row.woo_pet && row.woo_pet_availability === "available" ? (
                      <div>
                        <Switch
                          onChange={(e) => {
                            this.changeVideoCallStatus(e, row);
                          }}
                          checked={row.video_call_status}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          onColor={"#34bfa3"}
                          offColor={"#f4516c"}
                        />
                        <div className="text-sm">
                          {row.video_call_status ? "Available" : "Unavailable"}
                        </div>
                      </div>
                    ) :
                    row.woo_pet && row.woo_pet_availability === "sold" ?(
                      <div className="m-widget4__ext">
                       <div className="text-sm"><strong>Sold</strong></div>
                     </div>
                    ):
                    (
                      <div className="m-widget4__ext">
                        <div className="text-sm"><strong>Not added to <br/>Site</strong></div>
                      </div>
                    )}
                  </>
                ): (
                  <div className="m-widget4__ext">
                    <div className="text-sm"><strong>Sold</strong></div>
                  </div>
                )}
              </>
            ) : null}
          </div>
        );
      }
    }, 
    {
      dataField: 'createdBy', text: ' ', formatter: (cell, row) => {
        return ( 
          <Activity  row={row} created={row.createdMedicalRecord} updated={row.updatedMedicalRecord} deleted={row.deletedMedicalRecord}/>
        );
      },
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    } 
  ];


  buttonFormatter(cell, row, rowIndex) {

    let data = this.state.contentData;       
    let index = _.findIndex(data, {id: row.id});

    let previndex = (index == 0) ? null : (index - 1);
    let nextindex = index + 1;

    let prevEle = nextindex != null ? data[nextindex] ? data[nextindex].id : 0 : 0;
    let nextEle = previndex != null ? data[previndex] ? data[previndex].id : -1 : -1; 

    return (
      <div>
       { this.state.pdfOldVersion == true ?
      <span className="dropdown show">
          <span className="dropdown">             
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="far fa-eye"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">   
             <a
                href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${row.id}`}
                className="dropdown-item"
                target="_blank"        
               >
                <i className="fa fa-print"></i>Print
              </a>                     
             <a
                className="dropdown-item"
                href="#"
                onClick={(e) => {
                  this.openPdf(e, row.id)
                }}
              >
                <i className="fa fa-print"></i>Print (Old)
              </a>
            
            </div>
          </span>
        </span>:
         <button        
         className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
         title="View" disabled={this.props.pdfStatus}
       >
         <a
          href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${row.id}`}
          target="_blank"  
          >
         <i className="far fa-eye"></i>
         </a>
       </button>
         }
     
        {/* <button
          onClick={(e) => this.openPdf(e, row.id)}
          className="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
          title="View" disabled={this.props.pdfStatus}
        >
          <i className="far fa-eye"></i>
        </button> */}
        <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <NavLink
                to={`/medical-records/${row.id}/${prevEle}/${nextEle}`}
                className="dropdown-item"
                title="View"
              >
                <i className="la la-edit"></i> Edit
              </NavLink>

              {row.Contract != null ? <a
                className="dropdown-item"
                onClick={(e) => this.openDoPdf(e, row.id, 'customer')}
                disabled={this.props.pdfStatus}
                style={{ cursor: "pointer" }}
              >
                <i className="la la-file-alt"></i> WayBill ( Customer )
              </a> : ""}

              <a
                className="dropdown-item"
                onClick={(e) => this.openDoPdf(e, row.id, 'shop')}
                disabled={this.props.pdfStatus}
                style={{ cursor: "pointer" }}
              >
                <i className="las la-file-download"></i> WayBill ( Shop )
              </a>

              <a
                className="dropdown-item"
                onClick={(e) => {
                  this.openInstagramPostModal(e, row)
                }}
              >
                <i className="lab la-instagram"></i> Insta Caption
              </a>

              {row && row.woo_pet && row.Contract === null && row.woo_pet_availability !== "sold" && row.woo_page_status !== "private" ? (
                <button
                  className="dropdown-item"
                  onClick={(e) => this.openBoostWooProfileConfirmDialog(e, row)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="las la-rocket"></i>Boost Puppy in Website
                </button>
              ) : null}
              
              <a
                className="dropdown-item"
                onClick={(e) => {
                  row.Contract
                    ? this.openRejectModal(e)
                    : this.openConfirmModal(e, row.id)
                }}
              >
                <i className="la la-trash-o"></i> Delete
              </a>
            </div>
          </span>
        </span>
      </div>
    );
  }

  handleSelect(dates) {

    const [start, end] = dates;

    if (start) {
      _self.setState({ startDate: start })
    }

    if (end) {
      _self.setState({ endDate: end })
    }

    if (_self.state.startDate && _self.state.endDate) {
      _self.setState({ selected: _self.state.startDate + " - " + _self.state.endDate })
    }
  }

  handleChange(dates) {

    const [start, end] = dates;

    if (start) {
      _self.setState({ sDate: start })
    }

    if (end) {
      _self.setState({ eDate: end })
    }

    if (_self.state.sDate && _self.state.eDate) {
      _self.setState({ selected: _self.state.sDate + " - " + _self.state.eDate })
    }
  }

  customDateSort(a, b, order){
    if (order === 'asc')
    {
      return Date.parse(a) - Date.parse(b)
    }
   else if (order === 'desc') {
      return  Date.parse(b) - Date.parse(a) 
    }
  }

  handleChangeOption = (e) => {
    if(e && e.target){
      this.setState({
        [e.target.name]: e.target.value,
        customFormNotValid: false
      });
    }
  }

  globaleHandleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  setStartDate(date) {
    _self.setState({ endDate: null, startDate: date })
    _self.component.setOpen(true)
  }

  setEndDate(date) {
    _self.setState({ endDate: date })
  }

  async openPriceEditModal(e,medicalRecord){
    await this.setState({availableSubscribers: [], showNotify: false, price: "" });
    await this.props.getNotificationsByMedicalRecord(medicalRecord.id);
    await this.setState({ price : medicalRecord.price, editMedicalRecord : medicalRecord, priceError : false, isPriceEdit: true, notifySubscribers: false });
    $("#edit_price_modal").modal("show");  

  }

  async openStatusChangeModal(e,mRecord){
    e.preventDefault();
    const soldReason = mRecord.sold_reason ? mRecord.sold_reason : null;
    await this.props.getNotificationsByMedicalRecord(mRecord.id);
    this.setState({ selectedMedicalRecord:mRecord, soldReason : soldReason  });
    if (mRecord.woo_page_status) {     
      this.setState({ selectedWooPageStatusOption: mRecord.woo_page_status,  selectedWooPagePuppyStatusOption: mRecord.woo_pet_availability });
    }
    else {
      this.setState({ selectedWooPageStatusOption: this.wooPageStatusOptions.Public });
    }
    $('#woo_page_status_modal').modal('show');
  }

  openArrivalDateEditModal(event, medicalRecord) {
    event.preventDefault();
    if (medicalRecord) {
      this.setState({
        arrivalDate: moment(medicalRecord.arrival_date,"MM-DD-YYYY").toDate(),
        editMedicalRecord: medicalRecord,
        puppyBirthDate: medicalRecord.date_of_birth,
        arrivalDateError: false,
        validateArrivalDate: true,
        isArrivalDateEdit: true,
        arrivalDateValidationMessage: 'Arrival date should be 8 weeks greater than the selected "Date of Birth"',
        isArrivalDateValid: true,
      }, () => {
        this.calculatePetAgeOnArrival(this.state.arrivalDate);
        $("#edit_arrival_date_modal").modal("show");
      });
    }
  }

  onChangeArrivalDate = value => {
    if (value) {
      let date = moment(value, "MM-DD-YYYY").toDate();
      this.setState({ arrivalDate: date }, () => {
        this.calculatePetAgeOnArrival(date);
      });
    }
  }

  setValidateArrivalDate = (e, status) => {
    e.preventDefault();
    this.setState({ validateArrivalDate: status, arrivalDateError: false });
  }

  editArrivalDate() {
    if (this.state.arrivalDate) {
      let medicalRecordObj = this.state.editMedicalRecord;
      
      if (medicalRecordObj) {
        let medicalRecordId = medicalRecordObj.id;
        let arrivalDate = moment(this.state.arrivalDate).format("YYYY-MM-DD");    
        let petDateOfBirth = this.changeDateFormat(medicalRecordObj.date_of_birth, "MM-DD-YYYY", "YYYY-MM-DD");
        const PetAgeDifference = moment(this.state.arrivalDate).diff(petDateOfBirth, 'week');
        const PetAgeDifferenceByDays = moment(this.state.arrivalDate).diff(petDateOfBirth, 'day');

        if (this.state.validateArrivalDate) {
          if (PetAgeDifference >= 8) {
            medicalRecordObj.arrival_date = arrivalDate;
            medicalRecordObj.availablePetId = true;
            medicalRecordObj.date_of_birth = petDateOfBirth;       
            this.props.updateMedicalRecord(medicalRecordId, medicalRecordObj);     
            this.setState({ 
              arrivalDateError: false, 
              validateArrivalDate: true,
              petAgeOnArrival: null,        
            });
          } else {
            this.setState({ 
              arrivalDateError: true, 
              arrivalDateValidationMessage: 'Arrival date should be 8 weeks greater than the selected "Date of Birth"',
            }, () => {
              NotificationManager.warning('Invalid arrival date');
            });
          }
        } else {
          if (PetAgeDifferenceByDays > 0) {
            medicalRecordObj.arrival_date = arrivalDate;
            medicalRecordObj.availablePetId = true;
            medicalRecordObj.date_of_birth = petDateOfBirth;
            
            this.props.updateMedicalRecord(medicalRecordId, medicalRecordObj);
            this.setState({ 
              arrivalDateError: false,
              petAgeOnArrival: null,
            });
          } else {
            this.setState({ 
              arrivalDateError: true, 
              arrivalDateValidationMessage: 'Arrival date cannot be earlier or equal to the birthday',
              isArrivalDateValid: false
            }, () => {
              NotificationManager.warning('Invalid arrival date');
            });
          }
        }
      } else {
        this.setState({ arrivalDateError: true }, () => {
          NotificationManager.error("Medical record not found");
        });
      }
    } else {
      this.setState({ arrivalDateError: true });
    }
  }

  changeDateFormat = (date, currentFormat, requestFormat) => {
    if (moment.isMoment(date)) {
      return date.format(requestFormat);
    } else {
      let currentDateArr = date.split("-");
      let currentFormatArr = currentFormat.split("-");
      let requestFormatArr = requestFormat.split("-");
  
      if (currentDateArr.length > 2 && currentFormatArr.length > 2 && requestFormatArr.length > 2) {
        let currentDD, currentMM, currentYYYY;
        for (let i = 0; i < currentFormatArr.length; i++) {
          if (currentFormatArr[i] === "DD") {
            currentDD = i;
          }
          if (currentFormatArr[i] === "MM") {
            currentMM = i;
          }
          if (currentFormatArr[i] === "YYYY") {
            currentYYYY = i;
          }
        }
  
        let newDate = "";
        
        let requestDD, requestMM, requestYYYY;
        for (let i = 0; i < requestFormatArr.length; i++) {
          if (requestFormatArr[i] === "DD") {
            requestDD = currentDateArr[currentDD];
            newDate += requestDD;
            if ((requestFormatArr.length - 1) > i) {
              newDate += "-";
            }
          }
          if (requestFormatArr[i] === "MM") {
            requestMM = currentDateArr[currentMM];
            newDate += requestMM;
            if ((requestFormatArr.length - 1) > i) {
              newDate += "-";
            }
          }
          if (requestFormatArr[i] === "YYYY") {
            requestYYYY = currentDateArr[currentYYYY];
            newDate += requestYYYY;
            if ((requestFormatArr.length - 1) > i) {
              newDate += "-";
            }
          }
        }

        return newDate;
      }
    }
  }

  calculatePetAgeOnArrival = (arrivalDate) => {
    const medicalRecordObj = this.state.editMedicalRecord;

    if (medicalRecordObj) {
      arrivalDate = moment(arrivalDate).format("YYYY-MM-DD");
      let petDateOfBirth = this.changeDateFormat(medicalRecordObj.date_of_birth, "MM-DD-YYYY", "YYYY-MM-DD")
      let diffInDays = moment(arrivalDate).diff(petDateOfBirth , 'days');
      let amountWeeks = Math.floor(diffInDays/7);
      let remainingDays = diffInDays % 7;
      remainingDays = remainingDays.toFixed(0);
      let msg = `${amountWeeks} weeks, ${remainingDays} days`;
      if(diffInDays > 0){
        this.setState({petAgeOnArrival : msg});
      }else{
        this.setState({petAgeOnArrival : `Invalid arrival date`});
      }
    }
  }

  openPdf = (e, id) => {
    e.preventDefault();
    if (this.state.clickedId !== id) {
      this.setState({ clickedId: id });
    } else {
      if (this.props.data.medicalRecordsReducer.printMRecord)
        this.childDownload();
    }
  };

  openDoPdf = (e, id, type) => {
    e.preventDefault();

    if (type) {
      this.setState({ type: type })
    }

    if (this.state.tempCheckId !== id) {
        this.setState({ tempCheckId: id });
    }
    
    $("#section_select_modal").modal("show");

  };

  openBoostWooProfileConfirmDialog = (event, medicalRecord) => {
    event.preventDefault();
    if (medicalRecord && medicalRecord.id && medicalRecord.pet_id) {
      this.setState({ boostProfileMRId: medicalRecord.id, boostProfilePetId: medicalRecord.pet_id });
      $("#boost_woo_profile_modal").modal("show");
    }
  }

  handleBoostProfile = (event) => {
    event.preventDefault();
    const { boostProfileMRId } = this.state;
    this.props.boostWooStoreProfile(boostProfileMRId);
    this.setState({ isBoostProfileLoading: true });
  }

  generateWaybill(e){
    e.preventDefault();
    if(this.state.envelope || this.state.waybill || this.state.medical_record){
      $("#section_select_modal").modal("toggle");
      if (this.state.clickedIdDoPdf !== this.state.tempCheckId) {
        this.setState({ clickedIdDoPdf: this.state.tempCheckId });
      } else {
        if (this.props.data.medicalRecordsReducer.printMRecord)
          this.childDoDownload();
      }
    }else{
      NotificationManager.error("Please select at least one template to generate the PDF.");
    }
    
  }

  generateWaybillv2(e){
    if(this.state.envelope || this.state.waybill || this.state.medical_record){
     return true;
    }else{
      e.preventDefault();
      NotificationManager.error("Please select at least one template to generate the PDF.");
      return false;
    }
    
  }

  openCollarInsertPDF = async (e, id) => {
    e.preventDefault();

    let breeder_collar_inserts = await fetchBreederDeliveryRecordsByBreederId(id, moment(this.state.sDate).format("YYYY-MM-DD"), moment(this.state.eDate).format("YYYY-MM-DD"));
      
    breeder_collar_inserts = await breeder_collar_inserts.payload;

    this.setState({ clickedIdCollarInsert: id, breederMRData: breeder_collar_inserts.data });

    if (Object.keys(breeder_collar_inserts.data).length !== 0){
      await this.childCIDownload();
    }else{
      this.setState({ clickedIdCollarInsert: null, breederMRData: null });
      NotificationManager.error("No collars found.");
    }

  };

  acceptMethods(childDownload) {
    // Parent stores the method that the child passed
    this.childDownload = childDownload;
  }

  acceptMethodsForPdf(childDoDownload) {
    // Parent stores the method that the child passed
    this.childDoDownload = childDoDownload;
  }

  acceptMethodsForCollarInsertPdf(childCIDownload) {
    // Parent stores the method that the child passed
    this.childCIDownload = childCIDownload;
  }

  openRejectModal(e) {
    e.preventDefault();
    $("#reject_modal").modal("show");
  }

  openConfirmModal(e, mrId) {
    e.preventDefault();
    this.setState({ deleteMRId: mrId });
    $("#confirm_delete_modal").modal("show");
  }

  pinToTopUpdateQueue(status,row){  
    if(row && row.woo_pet && row.woo_pet_id && row.id){  
      const statusNew = status ? 'create':'remove';
      this.props.petPinToTop(row.id, statusNew);   
    }
  }

  openInstagramPostModal(e, row) {
    e.preventDefault();
    try{
      const allMedicalRecords = this.state.contentData;       
      const index = _.findIndex(allMedicalRecords, {id: row.id});
      if(index >= 0){
        row.arrival_date = allMedicalRecords[index] && allMedicalRecords[index].arrival_date ? this.changeDateFormat(allMedicalRecords[index].arrival_date,"MM-DD-YYYY","MM-DD-YYYY") : null;
      }else{
        NotificationManager.error("Insta caption can be generated for completed Medical Records only.");
      }
      if(row.price &&  row.arrival_date ){
        this.setState({ current_row: row });
        $("#instagram_post_modal").modal("show");
      }else{
        NotificationManager.error("Insta caption can be generated for completed Medical Records only.");
      }
    }catch(e){
      NotificationManager.error("Insta caption can be generated for completed Medical Records only.");
    }
    
    
  }

  openDeliveryModal(e, data) {
    e.preventDefault();
    let sdate = moment();
    let edate = moment().add(7, 'days');
    _self.setState({ startDate: sdate, endDate: edate });
    $("#breeder_delivery_list_modal").modal("show");
  }

  openCollerInsertModal(e, data) {
    e.preventDefault();
    let sdate = moment();
    let edate = moment().add(7, 'days');
    _self.setState({ sDate: sdate, eDate: edate });
    $("#collar_insert_modal").modal("show");
  }

  openWaybillForAllPetsModal(e, data) {
    e.preventDefault();
    let sdate = moment();
    let edate = moment().add(7, 'days');
    _self.setState({ sDate: sdate, eDate: edate });
    $("#waybill_for_all_modal").modal("show");
  }

  openChangeArrivalDateModal(){
    $("#change-arrival-date-modal").modal("show");
  }

  

  async breederCollarInserts(e){
    e.preventDefault();
    if(this.state.BreederId !== "N/A" && this.state.BreederId !== false){
      await this.openCollarInsertPDF(e, this.state.BreederId);
      $("#collar_insert_modal").modal("hide");
      this.setState({ BreederId: "N/A" });
    }else{
      NotificationManager.error("Please select breeder first");
    }
    
  }

  async breederCollarInsertsV2(e){
    e.preventDefault();
    if(this.state.BreederId !== "N/A" && this.state.BreederId !== false){
      let breeder_collar_inserts = await fetchBreederDeliveryRecordsByBreederId(this.state.BreederId, moment(this.state.sDate).format("YYYY-MM-DD"), moment(this.state.eDate).format("YYYY-MM-DD")).payload;
  
      if (Object.keys(breeder_collar_inserts.data).length !== 0){
        let colerInsertButton = document.getElementById('collar-insert-v2');
        setTimeout(() => {
          if (colerInsertButton) {
            colerInsertButton.click();
          }
        }, 200);
      }else{
        NotificationManager.error("No collars found.");
      }
    }else{
        e.preventDefault();
        NotificationManager.error("Please select breeder first");
    }
      
  }  

  async waybillGenerateCheck(e){
    if(this.state.BreederId !== "N/A" && this.state.BreederId !== false){
      try{
        await fetchWaybillsForAllPets(this.state.BreederId, moment(this.state.sDate).format("YYYY-MM-DD"), moment(this.state.eDate).format("YYYY-MM-DD")).payload;
        let link = document.getElementById('waybilll-for-all-pets');
        setTimeout(() => {
          if (link) {
            link.click();
          }
        }, 200);
      }catch(err){
        e.preventDefault();
        NotificationManager.error("No Waybills Found");
      }
    }else{
      e.preventDefault();
      NotificationManager.error("Please select breeder first");
    }
    
  }

  changeBreeder = selected => {
    if (selected) {
      this.setState({ BreederId: selected.value });
    }
  };

  changeVideoCallStatus = (checked, mrecord) => {    
    if (mrecord) {
      this.setState({ video_call_status:checked });     
      let medicalRecordObj = mrecord;
      let medicalRecordId = medicalRecordObj.id;
      medicalRecordObj.video_call_status = checked;
      medicalRecordObj.availablePetId = true;     
      this.props.updateVideoCallStatus(medicalRecordId, medicalRecordObj);
    }
  };

  editPrice(){
    if(this.state.price > 0){    
      let medicalRecordObj = this.state.editMedicalRecord;
      let medicalRecordId = medicalRecordObj.id;
      medicalRecordObj.price = this.state.price;
      medicalRecordObj.availablePetId = true;  
      medicalRecordObj.notifySubscribers = this.state.notifySubscribers
      this.setState({priceError: false});    
      this.props.updateMedicalRecord(medicalRecordId, medicalRecordObj);
    }else{
      this.setState({priceError: true});     
    }
  }

  changeWooPageStatusOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({
        selectedWooPageStatusOption: changedEvent.target.value,
        selectedWooPagePuppyStatusOption: ''
      });
    }
    else {
      this.setState({
        selectedWooPageStatusOption: this.wooPageStatusOptions.Public,
        selectedWooPagePuppyStatusOption: ''
      });
    }
  };

  changeWooPagePuppyStatusOption = (changedEvent) => {
    if (changedEvent && changedEvent.target && changedEvent.target.value) {
      this.setState({ selectedWooPagePuppyStatusOption: changedEvent.target.value, soldReason: null, });
    }
    else {
      this.setState({
        selectedWooPagePuppyStatusOption: this.wooPagePuppyStatusOptions.Available
      });
    }
  };

  updatedMedicalRecordList = () => {
    this.props.fetchMedicalRecords();
  }

  completeUpdateMedicalRecord(notify){
    let data = this.state.updateData;
    if(data){
      this.setState({ loadingInfo: true, loadingMultipleImages: false });
      data["notifySubscribers"] = notify;
      data["arrival_date"] = this.changeDateFormat(data["arrival_date"], "MM-DD-YYYY", "YYYY-MM-DD");
      data["date_of_birth"] = this.changeDateFormat(data["date_of_birth"], "MM-DD-YYYY", "YYYY-MM-DD");
      this.props.updateMedicalRecord(this.state.mRecord.id, data);
      $("#send_notification_model").modal("hide");
    }
    
  }

 componentDidMount() {   
     this.props.fetchMedicalRecords();
     this.props.fetchAnimalTypes();   
     this.props.fetchRegTypes();  
     this.props.fetchBreeders();
  
  }

  componentWillReceiveProps =  nextProps => {
    if (this.props.toa !== nextProps.toa) {    
      let i = 0;
      for (let t of nextProps.toa) {
        toaOptions[i] = t.type;
        i++;
      }
    }
    if (this.props.reg_types !== nextProps.reg_types) {     
      let i = 0;
      for (let t of nextProps.reg_types) {
        rtOptions[i] = t.type;
        i++;
      }
    } 

    if (
      nextProps.data.medicalRecordsReducer.mRecord !==
      this.props.data.medicalRecordsReducer.mRecord
    ) {
      this.props.fetchMedicalRecords();     
    } 

    if (  nextProps.data.medicalRecordsReducer.mRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords.length > 0 &&
      nextProps.data.medicalRecordsReducer.mRecords !==
      this.props.data.medicalRecordsReducer.mRecords 
    ) { 
      let records = nextProps.data.medicalRecordsReducer.mRecords.medicalRecords; 
      let pdfVersionStatus = nextProps.data.medicalRecordsReducer.mRecords.configPdfVersion;  
        records = records.map((record , index) => {
          if(record.Contract && record.Contract.Customer){
            record.customer = record.Contract.Customer.firstname+" "+ record.Contract.Customer.lastname;
          }
          return record;                 
        });
      records.sort((a, b) => (a.id > b.id ? -1 : 1));

      let cdDraft = records.filter(
        m => m.status === "Draft"
      );
      let cdAvailable = records.filter(     
        m => m.status === "Available" && m.woo_pet_availability ==="available"
      );
      let cdSold = records.filter(   
        m => m.status === "Sold" || m.woo_pet_availability === "sold"
      );

      let cdDeleted = records.filter(
        m => m.status === "Deleted"
      );   
      this.setState({
        contentData: records,
        cdAvailable: cdAvailable,
        cdSold: cdSold,
        cdDraft: cdDraft,
        cdDeleted: cdDeleted,
        pdfOldVersion : pdfVersionStatus,
        loadingMedicalRecords : false,
      });     
    }

    if (  nextProps.data.medicalRecordsReducer.mRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords &&
      nextProps.data.medicalRecordsReducer.mRecords.medicalRecords.length <= 0 &&
      nextProps.data.medicalRecordsReducer.mRecords !== this.props.data.medicalRecordsReducer.mRecords 
    ) {   
      NotificationManager.warning("Medical records not found."); 
      this.setState({ loadingMedicalRecords : false,});     
    }

    if (
      nextProps.data.medicalRecordsReducer.selectedToDelete !==
      this.props.data.medicalRecordsReducer.selectedToDelete
    ) {   
      this.setState({ loadingDelete: false });
      this.props.fetchMedicalRecords();
      NotificationManager.success("Medical Record Deleted Successfully");
      $("#confirm_delete_modal").modal("hide");
    }
    if (
      nextProps.data.medicalRecordsReducer.mRecord !==
      this.props.data.medicalRecordsReducer.mRecord
    ) {    
      this.props.fetchMedicalRecords();         
    }

    if (
      nextProps.data.medicalRecordsReducer.breedersDeliveryRecords !==
      this.props.data.medicalRecordsReducer.breedersDeliveryRecords
    ) {
      let BreederDeliveryrecords = nextProps.data.medicalRecordsReducer.breedersDeliveryRecords;
      this.setState({
        dataBreederDelivery: BreederDeliveryrecords,
        loadingBd: false
      });

      if(BreederDeliveryrecords.length === 0){
        NotificationManager.error("No Delivery Texts Found.");
      }
    }

    if (
      nextProps.data.medicalRecordsReducer.breedersDeliveryRecordsByBreederId !==
      this.props.data.medicalRecordsReducer.breedersDeliveryRecordsByBreederId
    ) {  
      let BreederDeliveryrecordsByBreederId = nextProps.data.medicalRecordsReducer.breedersDeliveryRecordsByBreederId;

      this.setState({
        dataBreederDeliveryByBreederId: BreederDeliveryrecordsByBreederId,
        loadingBd: false
      });
    }

    if (
      nextProps.breeders &&
      this.props.breeders !== nextProps.breeders &&
      nextProps.breeders.length > 0
    ) {     
      let options = [{ label: "Select an breeder", value: "N/A" }];
      nextProps.breeders.map(p => {
        options.push({ label: p.breeder, value: p.id });
      });
      this.setState({ breeders: options });
      if (nextProps.breeders.length > 0) {
        this.setState({ BreederId: "N/A" });
      }
    }

    if (this.props.data.medicalRecordsReducer.updatedMRecord !== nextProps.data.medicalRecordsReducer.updatedMRecord) {       
      this.props.fetchMedicalRecords();   
      if (this.state.isArrivalDateEdit) {
        NotificationManager.success("Arrival date updated successfully.");
      } else if (this.state.isPriceEdit) {
        NotificationManager.success("Price updated successfully.");
      } else if(this.state.video_call_status !==  this.props.data.medicalRecordsReducer.updatedMRecord.video_call_status    ){
        NotificationManager.success("Video call request updated successfully.");
      }
      $("#edit_price_modal").modal("hide");
      $("#edit_arrival_date_modal").modal("hide");
      this.setState({ isPriceEdit: false, isArrivalDateEdit: false });
    }

    if (this.props.data.medicalRecordsReducer.videoCallStatus !== nextProps.data.medicalRecordsReducer.videoCallStatus) {
      this.props.fetchMedicalRecords();
      NotificationManager.success("Video call status updated");
    }

    if (this.props.data.medicalRecordsReducer.videoCallStatusError !== nextProps.data.medicalRecordsReducer.videoCallStatusError) {
      if (nextProps.data.medicalRecordsReducer.videoCallStatusError && nextProps.data.medicalRecordsReducer.videoCallStatusError.details) {
        NotificationManager.error(nextProps.data.medicalRecordsReducer.videoCallStatusError.details.message);
      }
    }
 
    if (this.props.data.medicalRecordsReducer.boostWooProfile !== nextProps.data.medicalRecordsReducer.boostWooProfile) {
      this.setState({ isBoostProfileLoading: false, boostProfileMRId: '', boostProfilePetId: '' });
      $("#boost_woo_profile_modal").modal("hide");
      NotificationManager.success("Woo Store puppy profile moved to the top successfully");
    }

    if (this.props.data.medicalRecordsReducer.boostWooProfileError !== nextProps.data.medicalRecordsReducer.boostWooProfileError) {
      this.setState({ isBoostProfileLoading: false });
      if (
        nextProps.data.medicalRecordsReducer.boostWooProfileError &&
        nextProps.data.medicalRecordsReducer.boostWooProfileError.details &&
        nextProps.data.medicalRecordsReducer.boostWooProfileError.details.message
      ) {
        NotificationManager.error(nextProps.data.medicalRecordsReducer.boostWooProfileError.details.message);
      }
    }

    if (this.props.data.subscribeToPetReducer.subscribeToPetByMr !== nextProps.data.subscribeToPetReducer.subscribeToPetByMr) {
      this.setState({ availableSubscribers: nextProps.data.subscribeToPetReducer.subscribeToPetByMr });
    }

    if (nextProps.data.medicalRecordsReducer.updateWooPageStatus != null && 
      this.props.data.medicalRecordsReducer.updateWooPageStatus != nextProps.data.medicalRecordsReducer.updateWooPageStatus) {
      const SuccessCode = 200;
      const ErrorCode = 400;      
      if (nextProps.data.medicalRecordsReducer.updateWooPageStatus === SuccessCode) {
        this.props.fetchMedicalRecords();  
        this.setState({ selectedMedicalRecord: null, soldReason : null }); 
        $("#woo_page_status_modal").modal("hide");
        NotificationManager.success("Status Updated Successfully");
      }else if (nextProps.data.medicalRecordsReducer.updateWooPageStatus === ErrorCode) {
        NotificationManager.error("Failed to Update the Status");
        if(this.state.soldReason && soldReasonValues.find(record => (record.key === this.state.soldReason && record.notify === true))){
          $("#woo_page_status_modal").modal("show");
          $("#send_notification_model").modal("hide");
          this.setState({ soldReason: null });
        }
      }
      $("#send_notification_model").modal("hide");
      this.setState({ loadingWooPageStatus: false });
      this.props.fetchMedicalRecords();
    }
    
    if(nextProps.pinToTopQueue && this.props.pinToTopQueue !== nextProps.pinToTopQueue){     
      let upatePinToTop = nextProps.pinToTopQueue;
      if(upatePinToTop.status === 'create'){    
        NotificationManager.success("Woostore puppy added to Pin to top queue successfully.");
      }
      else{
        NotificationManager.success("Woostore puppy remove from Pin to top queue successfully.");
      }
      this.setState({ loadingPinToTop : false });    
      $('#pet_pin_to_top_modal').modal('hide');     
      this.props.fetchMedicalRecords(); 

    }  

   if(nextProps.pinToTopQueueError && this.props.pinToTopQueueError !== nextProps.pinToTopQueueError){  
     this.setState({ loadingPinToTop : false });  
     NotificationManager.error("An error occurred while updating the Website pin to top queue.");  
    $('#pet_pin_to_top_modal').modal('hide');    
   }

  
  };

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.clickedId && this.state.clickedId !== prevState.clickedId) {
      this.props.updatePrintMRecord(this.state.clickedId);
    }

    if (this.state.clickedIdDoPdf && this.state.clickedIdDoPdf !== prevState.clickedIdDoPdf) {
      this.setState({clickedId: null})
      this.props.updatePrintMRecord(this.state.clickedIdDoPdf);
    }

    if (
      this.props.data.medicalRecordsReducer.printMRecord &&
      prevProps.data.medicalRecordsReducer.printMRecord !==
      this.props.data.medicalRecordsReducer.printMRecord
    ) {

      if (this.state.clickedIdDoPdf) {
        this.childDoDownload();
      }

      if (this.state.clickedId) {
        this.childDownload();
      }

    }

  }  

  handleClickOpen = () => {
    this.setState({ openNew: true });
  };

  handleClose = value => {
    this.props.reset("newContractForm");
    this.setState({ openNew: false, confirmDelete: false });
    this.props.fetchMedicalRecords();
  };

  handleDeleteConfirm = () => {
    this.props.getDeletable(this.state.selected);
    this.handleClose();
  };

  handleDelete = selected => {
    if (!(selected === null || selected === undefined) && selected !== 0) {
      this.setState({ confirmDelete: true, selected });
    }
  };

  deleteMRecord() {
    this.setState({ loadingDelete: true });

    if (this.state.deleteMRId) this.props.deleteMRecords(this.state.deleteMRId);
    else {
      NotificationManager.warning("Invalid medical record.");
      this.setState({ loadingDelete: false });
    }
  }

  async breeder_delivery_list() {
    _self.setState({ loadingBd: true })
    await this.props.fetchBreederDeliveryRecords(moment(this.state.startDate).format("YYYY-MM-DD"), moment(this.state.endDate).format("YYYY-MM-DD"));
  }

  handleChildUnmount() {
    this.setState({ clickedId: false });
  }

  handleChildUnmountDoPdf() {
    this.setState({ clickedIdDoPdf: false });
  }

  handleChildUnmountCollarInsertPdf() {
    this.setState({ clickedIdCollarInsert: false, BreederId: false });
  }

  handleRedirectClick = () => {
    this.props.history.push("/medical-records/deleted");
  }

  getArrivalDate(row){
    if(row != null){
      let daysForAvailability = config.daysForAvailability ? config.daysForAvailability : 0;
      let arrival_date_moment = row.arrival_date; 
      let availability = "Now";
      arrival_date_moment = changeDateFormat(arrival_date_moment, "MM-DD-YYYY", "YYYY-MM-DD");
      let a = moment();
      let b = moment(arrival_date_moment);

      if(b.diff(a, 'days') > 0){
        arrival_date_moment = b.add(daysForAvailability, 'days').format("YYYY/MM/DD");
        arrival_date_moment = changeDateFormat(arrival_date_moment, "YYYY/MM/DD", "MM/DD/YYYY", "/");        
        //availability = "Now For Preorder";
        availability = "Now";
        return { date: arrival_date_moment, availability: availability };
      } else {
        arrival_date_moment = changeDateFormat(b.format("YYYY/MM/DD"), "YYYY/MM/DD", "MM/DD/YYYY", "/");
        return { date: arrival_date_moment , availability: availability };
      }
    }
  }

  copyPost(text, breeder_deliveries) {
    if (text) {
      copy(text);
      NotificationManager.success("Copy to clipboard");
    } else if (breeder_deliveries) {
      let cont = "";
      breeder_deliveries.forEach(breedersListData => {
        cont += `Pick up ${breedersListData.MedicalRecords.length} Puppies From:\n\n`
        cont += `${breedersListData.breeder}\n${formatPhoneNumber(breedersListData.phone)}\n${breedersListData.addressLine1}\n${breedersListData.addressLine2 || "-"},${breedersListData.addressCity || "-"},${breedersListData.addressState || "-"},${breedersListData.addressPostalCode || "-"}\n`
        cont += `\nDrop off:\n\n`

        breedersListData.MedicalRecords.map((b, id) => {

          if (b.Contract != null) {
            cont += `${b.Contract.Customer.firstname} ${b.Contract.Customer.lastname}\n`
            cont += `${b.Contract.Customer.address},${b.Contract.Customer.city}\n`
            cont += `${b.Contract.Customer.state} ${b.Contract.Customer.zip_code}\n`
            cont += `${formatPhoneNumber(b.Contract.Customer.phone_primary)} ${b.Contract.Customer.phone_secondary ? " or " + formatPhoneNumber(b.Contract.Customer.phone_secondary) : ""}\n`
          } else {
            cont += `${b.PetShop.title}\n`
            cont += `${b.PetShop.address},${b.PetShop.country}\n`
            cont += `${formatPhoneNumber(b.PetShop.phone_number)}\n`
          }

          cont += `${b.Breed.breed_type || "-"} | ${b.sex || "-"} | ID : ${b.pet_id || "-"}\n`

        })

        cont += "\n"

      });

      copy(cont);
      NotificationManager.success("Copy to clipboard");
    }

  }

  setWooPageStatus = (notify) => {
    if(this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold && !this.state.soldReason || this.state.soldReason === "Select Reason"){
      this.setState({customFormNotValid: true});
      return false;
    }
    if ( this.state.selectedMedicalRecord.id
      && this.state.selectedMedicalRecord.woo_pet_id 
      && this.state.selectedMedicalRecord.woo_pet 
      && this.state.selectedMedicalRecord.mc_status === 'complete') {
        this.setState({ loadingWooPageStatus: true });
        this.props.updateWooPageStatus(this.state.selectedMedicalRecord.id, {
          wooPageStatus: this.state.selectedWooPageStatusOption,
          wooPagePuppyStatus: this.state.selectedWooPagePuppyStatusOption,
          wooPetId: this.state.selectedMedicalRecord.woo_pet_id,
          reason: this.state.soldReason ? this.state.soldReason : "",
          notifySubscribers: notify
        });
    }
  };

  changeStateOfSoldPopUp(){ 
    if(this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold && !this.state.soldReason || this.state.soldReason === "Select Reason"){
      this.setState({customFormNotValid: true});
      return false;
    }
    $("#woo_page_status_modal").modal("hide");
    $("#send_notification_model").modal("show");
  }

  cancelProcess(){
    this.setState({ loadingInfo: false, loadingMultipleImages: false });
  }

  copyWooPageUrl = () => {
    if (this.state.selectedMedicalRecord && this.state.selectedMedicalRecord.woo_permalink) {
      copy(this.state.selectedMedicalRecord.woo_permalink);
      NotificationManager.success("Copied to clipboard");
    }
  };

  capitalizeFirstLetter(string) 
  {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  heshe(string) 
  {
      let hs = string.toLowerCase() == "male" ? "him" : "her";
      return hs;
  }

  checkboxHandler(template_label){

    if(template_label == "envelope"){
      let val = !this.state.envelope;
      this.setState({"envelope": val}, this.urlBuilder(template_label, val))      
    }

    if(template_label == "waybill"){
      let val = !this.state.waybill;
      this.setState({"waybill": val}, this.urlBuilder(template_label, val))
    }

    if(template_label == "medical_record"){
      let val = !this.state.medical_record
      this.setState({"medical_record": val}, this.urlBuilder(template_label, val))
    }  
    
    
    
  }

  urlBuilder(template_label, val){
    if(template_label == "envelope"){

      if(val){
        if(this.state.url_build == "?"){
          this.setState({url_build: this.state.url_build+"envelope=true"})
        }else{
          this.setState({url_build: this.state.url_build+"&&envelope=true"})
        }
        
      }else{
        if(this.state.url_build !== "?"){
          let str = this.state.url_build;

          if(str.indexOf("envelope=true") == 1){
            if(str.indexOf("envelope=true&&")){
              let newStr = str.replace("envelope=true&&", "");
              this.setState({url_build: newStr})
            }else{
              let newStr = str.replace("envelope=true", "");
              this.setState({url_build: newStr})
            }
            
          }else{
            let newStr = str.replace("&&envelope=true", "");
            this.setState({url_build: newStr})
          }
        }  
      }
      
    }

    if(template_label == "waybill"){

      if(val){

        if(this.state.url_build == "?"){
          this.setState({url_build: this.state.url_build+"waybill=true"})
        }else{
          this.setState({url_build: this.state.url_build+"&&waybill=true"})
        }
        
      }else{
        if(this.state.url_build != "?"){
          let str = this.state.url_build;

          if(str.indexOf("waybill=true") == 1){
            if(str.indexOf("waybill=true&&")){
              let newStr = str.replace("waybill=true&&", "");
              this.setState({url_build: newStr})
            }else{
              let newStr = str.replace("waybill=true", "");
              this.setState({url_build: newStr})
            }
          }else{
            let newStr = str.replace("&&waybill=true", "");
            this.setState({url_build: newStr})
          }
        }  
      }
    }

    if(template_label == "medical_record"){      

      if(val){

        if(this.state.url_build == "?"){
          this.setState({url_build: this.state.url_build+"medicalrecord=true"})
        }else{
          this.setState({url_build: this.state.url_build+"&&medicalrecord=true"})
        }
        
      }else{
        if(this.state.url_build !== "?"){
          let str = this.state.url_build;

          if(str.indexOf("medicalrecord=true") == 1){

            if(str.indexOf("medicalrecord=true&&")){
              let newStr = str.replace("medicalrecord=true&&", "");
              this.setState({url_build: newStr})
            }else{
              let newStr = str.replace("medicalrecord=true", "");
              this.setState({url_build: newStr})
            } 
          }else{
            let newStr = str.replace("&&medicalrecord=true", "");
            this.setState({url_build: newStr})
          }
        }  
      }

    }
  }

  changePrice = event => {
    this.setState({ price: event.target.value });
    
    if(this.state.editMedicalRecord.price > event.target.value && this.state.editMedicalRecord.price !== parseFloat(event.target.value).toFixed(2)){
      this.setState({ showNotify: true });
    }else{
      this.setState({ showNotify: false });
    }
  };

  incrementPrice = (event) => {
    event.preventDefault();
    let price = parseFloat(this.state.price);
    price += 50;
    this.setState({ price: price.toFixed(2) })
  }

  decrementPrice = (event) => {
    event.preventDefault();
    let price = parseFloat(this.state.price);
    price -= 50;
    this.setState({ price: price.toFixed(2) })
  }

  handleCouponChange = (e) => {
    e.preventDefault();
    this.setState({ selectedTab: "Coupon" });
    //this.props.fetchMedicalRecordsByAge();
  }

  items = [{ title: "Puppy Records", to: "/medical-records" }];

  render() {
    const { classes, theme, pdfStatus } = this.props;
    const {
      contentData,
      cdAvailable,
      cdSold,
      cdDraft,
      cdDeleted,
      current_row,
      startDate,
      endDate,
      selected,
      sDate,
      eDate,
      breeders,
      BreederId,
      price,
      priceError,
      petAgeOnArrival,
      boostProfilePetId,
      isBoostProfileLoading,
      loadingMedicalRecords,
      soldReason,
      isPinToTop,
      loadingPinToTop,
      pinToTopSelectedPetId,
    } = this.state;

    let arrival_date_moment = this.getArrivalDate(current_row);

    let dob_moment = "";

    if (current_row != null) {
      let b = new Date(current_row.date_of_birth.replace(/-/g, "/"));
      dob_moment = moment(b).format("MM/DD/YYYY");
    }

    let formattedPrice = 0;

    if(current_row){
      formattedPrice = current_row.price.toString().replace(/\.00$/,'');
    }

    let sex_lc = current_row != null ? this.capitalizeFirstLetter(current_row.sex): "";
    let breedtype_lc = current_row != null ? normalToPascal(current_row.Breed.breed_type).replace(/\s/g, '') : "";
    let postText = "";
    let heshe = current_row != null ? this.heshe(current_row.sex) : "";
    if (this.state.current_row != null) {
      let aw = current_row.adult_weight ? "• Estimated Adult Weight: " + current_row.adult_weight + " lbs" : "• Estimated Adult Weight: N/A";
      postText = `
🐶 (Available ${arrival_date_moment.availability}) #${breedtype_lc} • Visit Website Linked In Our Profile. 

Regulated Business USDA license No.968 

• Estimated Home Delivery Date: ${arrival_date_moment.date} (Plus Or Minus 1 Day).

ℹ️ Puppy Information: 
Site Reference Puppy ID: ${current_row.pet_id} • ${sex_lc} • DOB: ${dob_moment} ${aw}.

🧑‍💻 Simple Process Via: www.centralpups.com

🐾 Free Delivery To Your Home 
🐾 Fully Vaccinated Up-To-Date 
🐾 Congenital Health Guarantee 
🐾 Microchip Included 
🐾 BBB Accredited A+ Rating 
🐾 Responsible Breeder Guarantee 

❤️ See Highlights Of Our Puppies In Their Forever Homes. 

👯 Tag a friend who would like this pup! 

🚐 FREE Home Delivery To Following States Only: NY, NJ, CT, FL, GA, MD, VA, SC, NC, RI, TN, VT, MS, AL, LA, PA, MA, DE, NH, ME, IL, IN, KY, MI, OH, WV, AR, KS, MO & DC.
              `
    }

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set" >
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Puppy Records                      
                      </h3>
                    </div>
                  </div>
                  <div className="medical-record-button-container">                  
                    { this.state.selectedTab !== "Coupon" &&
                    <>
                      <div className="m-portlet__head-tools breed-delivery-record-btn">
                        <NavLink
                          to={`/medical-records/add`}
                          className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                        >
                          <span>
                            <i className="la la-plus"></i>
                            <span>New Puppy Record</span>
                          </span>
                        </NavLink>
                      </div>
                      <div className="m-portlet__head-tools breed-delivery-record-btn">
                        <div
                          className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                          onClick={this.openWaybillForAllPetsModal}
                        >
                          <span>
                            <i className="las la-file-download"></i>
                            <span>Waybills</span>
                          </span>
                        </div>
                      </div>
                      <div className="m-portlet__head-tools breed-delivery-record-btn">
                        <div
                          className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                          onClick={this.openCollerInsertModal}
                        >
                          <span>
                            <i className="las la-tshirt"></i>
                            <span>Collar Inserts</span>
                          </span>
                        </div>
                      </div>
                      <div className="m-portlet__head-tools breed-delivery-record-btn">
                      <div
                        className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"
                        onClick={this.openDeliveryModal}
                      >
                        <span>
                          <i className="las la-truck"></i>
                          <span>Deliveries Text</span>
                        </span>
                      </div>               
                  

                      </div>
                      <div className="m-portlet__head-tools  breed-delivery-record-btn">
                      <div
                        className="m-nav__link btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill"          
                        onClick={this.openChangeArrivalDateModal}
                    >
                        <span>
                          <i className="las la-calendar"></i>
                          <span>Change Arrival Date</span>
                        </span>
                      </div>
                      </div>
                    </>
                    }             
                  </div>
                </div>
                <div className="m-portlet__body medical-record-content">
                  <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >               
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "All"
                        })}
                        onClick={() => this.setState({ selectedTab: "All" })}
                      >
                        All
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Available"
                        })}
                        onClick={() =>
                          this.setState({ selectedTab: "Available" })
                        }
                      >
                        Available
                      </a>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Draft"
                        })}
                        onClick={() => this.setState({ selectedTab: "Draft" })}
                      >
                        Draft
                      </a>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Sold"
                        })}
                        onClick={() => this.setState({ selectedTab: "Sold" })}
                      >
                        Sold
                      </a>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Coupon"
                        })}
                        onClick={(e) => this.handleCouponChange(e)}
                      >
                        Coupons
                      </a>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "Deleted"
                        })}
                        onClick={() => this.handleRedirectClick()}
                      >
                        Deleted
                      </a>
                    </li>               
                  </ul>

                  <div className="tab-content">
                  { this.state.selectedTab !== 'Coupon' && !loadingMedicalRecords ?
                    <ToolkitProvider
                       keyField="id"
                       data={
                        this.state.selectedTab === "All"
                          ? contentData
                          : this.state.selectedTab === "Available"
                            ? cdAvailable
                            : this.state.selectedTab === "Sold"
                              ? cdSold
                              : this.state.selectedTab === "cdDeleted"
                                ? cdDeleted
                                : this.state.selectedTab === "Draft"
                                  ? cdDraft 
                                  : {}
                      }
                      columns={this.tableHeaderColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>
                          <div className="mb-2">
                            <small className="small-text">
                              *If you experience any difficulty in viewing the
                              medical record, please make sure your cache is
                              cleared and completed a hard refresh. IOS users
                              might have to use a private window.
                            </small>
                          </div>
                          {!pdfStatus ?
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                            />
                            : <div className={"loader-center"}>
                              <Loader
                                type="line-scale"
                                active={true}
                                className="loader-center"
                              />
                            </div>}
                        </div>
                      )}
                    </ToolkitProvider>
                    : this.state.selectedTab !== 'Coupon' &&
                     <div className="center-row">
                      <Loader size={50} />
                    </div>
                    }                   
                    {this.state.selectedTab === 'Coupon' &&
                      <div className="tab-pane active" id="m_tabs_6_1" role="tabpanel">
                         <Coupon />
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="confirm_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to delete
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete this medical record?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loadingDelete == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteMRecord()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="reject_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="RejectModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Not allowed
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        This medical record is associated with a contract.
                        Please delete the contract first.
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary m-btn--pill mx-2"
                        data-dismiss="modal"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="instagram_post_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="InstagramPostLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Post
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {this.state.current_row != null ? (
                        <div>
                          <p className="post-content">
                            🐶 (Available {arrival_date_moment.availability}) #{breedtype_lc || ""} • Visit Website Linked In Our Profile. 
                            <br/><br/>
                            Regulated Business USDA license No.968
                            <br/><br/>
                            • Estimated Home Delivery Date: {arrival_date_moment.date || ""} (Plus Or Minus 1 Day).<br/>
                            <br/>
                            ℹ️ Puppy Information: <br/>
                            Site Reference Puppy ID: {current_row.pet_id || ""} • {sex_lc || ""} • DOB: {dob_moment || ""} {current_row.adult_weight ? "• Estimated Adult Weight: " + current_row.adult_weight + " lbs" : "• Estimated Adult Weight: N/A"}. <br/>
                            <br/>
                            🧑‍💻 Simple Process Via: www.centralpups.com<br/>
                            <br/>
                            🐾 Free Delivery To Your Home <br/>
                            🐾 Fully Vaccinated Up-To-Date <br/>
                            🐾 Congenital Health Guarantee <br/>
                            🐾 Microchip Included <br/>
                            🐾 BBB Accredited A+ Rating <br/>
                            🐾 Responsible Breeder Guarantee <br/>
                            <br/>
                            ❤️ See Highlights Of Our Puppies In Their Forever Homes. <br/>
                            <br/>
                            👯 Tag a friend who would like this pup! <br/>
                            <br/>
                            🚐 FREE Home Delivery To Following States Only: NY, NJ, CT, FL, GA, MD, VA, SC, NC, RI, TN, VT, MS, AL, LA, PA, MA, DE, NH, ME, IL, IN, KY, MI, OH, WV, AR, KS, MO & DC.
                          </p>
                        </div>
                        
                      ) : ""}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-primary m-btn--pill mx-2"
                        onClick={() => this.copyPost(postText)}
                      >
                        Copy
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="modal fade"
                id="breeder_delivery_list_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        View Delivery List
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div>
                        <div style={{ textAlign: "center" }}>

                          <Mobile>
                            <DateRangePicker
                              startDate={startDate} // momentPropTypes.momentObj or null,
                              startDateId="123123121321321" // PropTypes.string.isRequired,
                              endDate={endDate} // momentPropTypes.momentObj or null,
                              endDateId="21231321321" // PropTypes.string.isRequired,
                              onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                              focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                              onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                              isOutsideRange={() => false}
                              orientation={orientation}
                            />
                          </Mobile>
                          

                          <Default>
                            <DateRangePicker
                              startDate={startDate} // momentPropTypes.momentObj or null,
                              startDateId="123123121321321" // PropTypes.string.isRequired,
                              endDate={endDate} // momentPropTypes.momentObj or null,
                              endDateId="21231321321" // PropTypes.string.isRequired,
                              onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })} // PropTypes.func.isRequired,
                              focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                              onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                              isOutsideRange={() => false}
                              orientation={orientation}
                            />
                          </Default>

                          <div style={{ clear: "both" }}></div>

                          <div style={{ width: "100%", marginTop: "21px" }}>
                            <button
                              type="button"
                              className="btn btn-primary m-btn--pill mx-2"
                              onClick={() => this.breeder_delivery_list()}
                            >
                              Submit
                              </button>
                          </div>

                        </div>

                        <div>
                          {this.state.loadingBd == false ?
                            <div id="breeder_delivery_list">
                              {this.state.dataBreederDelivery != null ?
                                this.state.dataBreederDelivery.map((breedersListData, id) => {
                                  return (
                                    <div>
                                      <div>Pick up {breedersListData.MedicalRecords.length} Puppies From:</div>
                                      <br />
                                      <div style={{ textTransform: "capitalize" }}>{breedersListData.breeder}</div>
                                      <div>{formatPhoneNumber(breedersListData.phone)}</div>
                                      <div dangerouslySetInnerHTML={{ __html: breedersListData.addressLine1 }}></div>
                                      <div>{breedersListData.addressLine2 ? breedersListData.addressLine2 + ", " : ""}{breedersListData.addressCity ? breedersListData.addressCity + ", " : ""}{breedersListData.addressState ? breedersListData.addressState + " " : ""}{breedersListData.addressPostalCode || ""}</div>
                                      <br />
                                      <div>Drop off:</div>
                                      <br />

                                      {breedersListData.MedicalRecords.map((b, id) => {
                                        return (
                                          <div key={id}>
                                            { b.Contract != null ?

                                              <div>
                                                <div style={{ textTransform: "capitalize" }}>{b.Contract.Customer.firstname} {b.Contract.Customer.lastname}</div>
                                                <div>{b.Contract.Customer.address}</div>
                                                <div>{b.Contract.Customer.city}, {b.Contract.Customer.state} {b.Contract.Customer.zip_code}</div>
                                                <div>{formatPhoneNumber(b.Contract.Customer.phone_primary)} {b.Contract.Customer.phone_secondary ? " or " + formatPhoneNumber(b.Contract.Customer.phone_secondary) : ""}</div>
                                              </div>

                                              :
                                              <div>
                                                <div>{b.PetShop.title}</div>
                                                <div dangerouslySetInnerHTML={{ __html: b.PetShop.address }}></div>
                                                <div>{formatPhoneNumber(b.PetShop.phone_number)}</div>
                                              </div>
                                            }

                                            <div>{b.Breed.breed_type}&nbsp;|&nbsp;{b.sex}&nbsp;|&nbsp;ID&nbsp;:&nbsp;{b.pet_id}</div>
                                            <br />
                                          </div>
                                        )
                                      })}
                                    </div>
                                  )
                                })

                                : "No records found."}
                            </div>
                            :
                            <div className={"loader-center"}>
                              <Loader
                                type="line-scale"
                                active={true}
                                className="loader-center"
                              />
                            </div>
                          }

                          {this.state.dataBreederDelivery.length ?
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-primary m-btn--pill mx-2"
                                onClick={() => this.copyPost(null, this.state.dataBreederDelivery)}
                              >
                                Copy
                                </button>
                            </div>
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Waybill For All Pets */}
              <div
                className="modal fade"
                id="waybill_for_all_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Waybill For All Pets
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div>
                        <div style={{ textAlign: "center" }}>
                          <div>
                            <Mobile>
                              <DateRangePicker
                                startDateId="startDate12"
                                endDateId="endDate12"
                                startDate={this.state.sDate}
                                endDate={this.state.eDate}
                                onDatesChange={({ startDate, endDate }) => {
                                  this.setState({ sDate: startDate, eDate: endDate });
                                }}
                                focusedInput={this.state.focusedInputCIWaybill}
                                onFocusChange={focusedInput => {
                                  this.setState({ focusedInputCIWaybill: focusedInput });
                                }}
                                orientation={orientation}
                              />
                            </Mobile>

                            <Default>
                              <DateRangePicker
                                startDateId="startDate12"
                                endDateId="endDate12"
                                startDate={this.state.sDate}
                                endDate={this.state.eDate}
                                onDatesChange={({ startDate, endDate }) => {
                                  this.setState({ sDate: startDate, eDate: endDate });
                                }}
                                focusedInput={this.state.focusedInputCIWaybill}
                                onFocusChange={focusedInput => {
                                  this.setState({ focusedInputCIWaybill: focusedInput });
                                }}
                                orientation={orientation}
                              />
                            </Default>

                            <div className="form-group m-form__group row">
                              <div style={{width: "60%", margin: "0 auto", marginTop: "15px"}}>
                                <Select
                                  options={breeders}
                                  value={BreederId}
                                  name="BreederId"
                                  onChange={this.changeBreeder}
                                  placeholder="Select The Breeder"
                                />
                              </div>
                            </div>

                          </div>  

                          <div style={{ width: "100%", marginTop: "21px" }}>
                            {/* <button
                              type="button"
                              className="btn btn-primary m-btn--pill mx-2"
                              onClick={(e) => this.breederCollarInserts(e)}
                            >
                              Submit
                              </button> */}

                            <button
                              className="btn btn-primary m-btn--pill mx-2"
                              target="_blank"
                              onClick={(e) => this.waybillGenerateCheck(e)}
                              style={{color: "#FFF"}}
                            >
                              Submit
                            </button> 
                            <a
                              className="btn btn-primary m-btn--pill mx-2"
                              id="waybilll-for-all-pets"  
                              href={`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/waybill-for-all/${this.props.data.petShopReducer.currentPetshop.id}/${this.state.BreederId}/${moment(this.state.sDate).format("YYYY-MM-DD")}/${moment(this.state.eDate).format("YYYY-MM-DD")}`}
                              target="_blank"
                              style={{display: "none"}}
                            >
                            </a>  
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Collar Insert */}
              <div
                className="modal fade"
                id="collar_insert_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Generate Collar Inserts
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div>
                        <div style={{ textAlign: "center" }}>
                          <div>
                            <Mobile>
                              <DateRangePicker
                                startDateId="startDate1"
                                endDateId="endDate1"
                                startDate={this.state.sDate}
                                endDate={this.state.eDate}
                                onDatesChange={({ startDate, endDate }) => {
                                  this.setState({ sDate: startDate, eDate: endDate });
                                }}
                                focusedInput={this.state.focusedInputCI}
                                onFocusChange={focusedInput => {
                                  this.setState({ focusedInputCI: focusedInput });
                                }}
                                orientation={orientation}
                              />
                            </Mobile>

                            <Default>
                              <DateRangePicker
                                startDateId="startDate1"
                                endDateId="endDate1"
                                startDate={this.state.sDate}
                                endDate={this.state.eDate}
                                onDatesChange={({ startDate, endDate }) => {
                                  this.setState({ sDate: startDate, eDate: endDate });
                                }}
                                focusedInput={this.state.focusedInputCI}
                                onFocusChange={focusedInput => {
                                  this.setState({ focusedInputCI: focusedInput });
                                }}
                                orientation={orientation}
                              />
                            </Default>

                            <div className="form-group m-form__group row">
                              <div style={{width: "60%", margin: "0 auto", marginTop: "15px"}}>
                                <Select
                                  options={breeders}
                                  value={BreederId}
                                  name="BreederId"
                                  onChange={this.changeBreeder}
                                  placeholder="Select The Breeder"
                                />
                              </div>
                            </div>

                          </div>  

                          <div style={{ width: "100%", marginTop: "21px" }}>
                          { this.state.pdfOldVersion == true &&(
                            <button
                              type="button"
                              className="btn btn-primary m-btn--pill mx-2"
                              onClick={(e) => this.breederCollarInserts(e)}
                            >
                               Submit (Old)
                              </button>
                          )}

                            <button
                              type="button"
                              className="btn btn-primary m-btn--pill mx-2"
                              onClick={(e) => this.breederCollarInsertsV2(e)}
                            >
                              Submit
                            </button>    

                            <a 
                              href={`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/collar-inserts/pdf/${this.props.data.petShopReducer.currentPetshop.id}/${this.state.BreederId}/${moment(this.state.sDate).format("YYYY-MM-DD")}/${moment(this.state.eDate).format("YYYY-MM-DD")}`}  
                              type="button"
                              className="btn btn-primary m-btn--pill mx-2"
                              id="collar-insert-v2"
                              target="_blank"
                              style={{display: "none"}}
                            >
                              Submit V2
                            </a>  
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* boost woo pet confirmation */}
              <div
                className="modal fade"
                id="boost_woo_profile_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="SectionSelectModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          Boost Puppy in Website
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                      Move puppy <strong>({boostProfilePetId !== '' ? boostProfilePetId : ''})</strong> to first position in website?
                    </div>

                    <div className="modal-footer">
                      {isBoostProfileLoading ? (
                        <Loader size={50} />
                      ) : (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            No
                          </button>
                          <button
                            type="button"
                            onClick={(e) => this.handleBoostProfile(e)}
                            className="btn btn-primary m-btn--pill"
                          >
                            Yes
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* waybill section selelctor */}
              <div
                className="modal fade"
                id="section_select_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="SectionSelectModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Select Documents (To {this.capitalizeFirstLetter(this.state.type) } )
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                        <div>
                          <label htmlFor="envilop_cover" style={{width: "180px"}}>Envelope Cover</label><input type="checkbox" name="envelope_cover" id="envelope_cover" onChange={(e) => this.checkboxHandler("envelope")}/>
                        </div>
                        <div>
                          <label htmlFor="waybill" style={{width: "180px"}}>Waybill</label><input type="checkbox" name="waybill" id="waybill" onChange={(e) => this.checkboxHandler("waybill")}/>
                        </div>
                        <div>
                          <label htmlFor="medical_record" style={{width: "180px"}}>Medical Record</label><input type="checkbox" name="medical_record" id="medical_record" onChange={(e) => this.checkboxHandler("medical_record")}/>
                        </div>
                    </div>
                    <div className="modal-footer">

                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          { this.state.pdfOldVersion == true &&(
                          <button
                            type="button"
                            onClick={(e) => this.generateWaybill(e)}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm (Old)
                          </button>
                          )}

                          {this.state.type == "customer" ? <a
                            className="btn btn-primary m-btn--pill"
                            href={`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/waybill/${this.props.data.petShopReducer.currentPetshop.id}/${this.state.tempCheckId+this.state.url_build}&&customer=true`}
                            style={{ cursor: "pointer", marginLeft: "7px" }}
                            target="_blank"
                            onClick={(e) => this.generateWaybillv2(e)}
                          >
                            <i className="la la-file-alt"></i> Confirm 
                          </a> : ""}

                          {this.state.type == "shop" ? <a
                            className="btn btn-primary m-btn--pill"
                            href={`${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/waybill/${this.props.data.petShopReducer.currentPetshop.id}/${this.state.tempCheckId+this.state.url_build}`}
                            style={{ cursor: "pointer", marginLeft: "7px" }}
                            target="_blank"
                            onClick={(e) => this.generateWaybillv2(e)}
                          >
                            <i className="la la-file-alt"></i> Confirm 
                          </a> : ""}
                        </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* en waybill sectoin selector */}
              {/* start price edit */}
              <div
                className="modal fade"
                id="edit_price_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="SectionSelectModalLabel"
                aria-hidden="true"             
              >
                <div className="modal-dialog modal-md" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit Price
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                    <form>
                    <div className="m-form form-group m-form__group row mb-0">
                      <label className="col-lg-4 pt-3">
                        Price:
                      </label>
                      <div className="col-lg-8 input-group m-input-group pl-0">
                        <div className="input-group-prepend">
                          <button className="btn btn-success price-btn-decrement" onClick={this.decrementPrice}>-</button>
                        </div>
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            $
                          </span>
                        </div>
                        <input
                          type="number"           
                          step={50}                            
                          value={price > 0 ? price : ""}
                          onChange={this.changePrice}
                          className="form-control m-input"                                      
                          aria-describedby="basic-addon1"
                        />   
                        <div className="input-group-prepend">
                          <button className="btn btn-success price-btn-increment" onClick={this.incrementPrice}>+</button>
                        </div>                           
                        </div>                                            
                      </div>
                      <div className="m-form row pt-0">   
                        <div className="col-12 pt-0" style={{textAlign:"center"}}>     
                        <span
                          className={
                          priceError == true ?
                          "m-form__help_danger"
                          : "display-none"
                          }
                        >
                          Select the price
                       </span> 
                       </div>
                       </div>

                       <br/>
                       {this.state.showNotify && this.state.availableSubscribers.length > 0 && this.state.editMedicalRecord.Contract === null ? <div>
                          <input type="checkbox" name="notifySubscribers" checked={this.state.notifySubscribers}   onChange={(e) => {
                            this.globaleHandleChange({
                              target: {
                                name: 'notifySubscribers',
                                value: e.target.checked,
                              },
                            });
                          }}/> <label style={{fontSize: 9}}>Notify subscribers of the changes</label>
                       </div> : ""}
                        	                   
	                   </form>               
                    </div>
                    <div className="modal-footer">
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={(e) => this.editPrice(e)}
                            className="btn btn-primary m-btn--pill"
                          >
                            Submit
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
           
              {/* end price edit */}

              {/* start arrival date edit */}
              <div className="modal fade" id="edit_arrival_date_modal" tabIndex="-1" role="dialog"
                aria-labelledby="SectionSelectModalLabel"
                aria-hidden="true"             
              >
                <div className="modal-dialog modal-sm" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit Arrival Date
                      </h5>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form>
                        <div className="m-form form-group m-form__group mb-0">
                          <label>Arrival Date</label>
                          <div>
                            <DatePicker
                              selected={Date.parse(this.state.arrivalDate)}
                              value={Date.parse(this.state.arrivalDate)}
                              onChange={this.onChangeArrivalDate}
                              onSelect={this.onChangeArrivalDate}
                              className="form-control m-input arrival-date-update-field"
                            />
                          </div> 
                          {petAgeOnArrival && (
                            <strong className="text-muted">Pet's age on arrival: {petAgeOnArrival}</strong>
                          )}                                           
                        </div>
                        <div className="m-form row pt-0">   
                          <div className="col-12 pt-0" style={{textAlign:"left"}}>     
                            <span className={this.state.arrivalDateError == true ? "m-form__help_danger" : "display-none"}>
                              {this.state.arrivalDateValidationMessage}
                              {this.state.isArrivalDateValid ? 
                                <button className="btn btn-outline-success btn-sm m-btn--pill ml-1" 
                                  onClick={(e) => this.setValidateArrivalDate(e, false)}
                                >Ignore</button> 
                                : null }
                            </span> 
                          </div>
                        </div> 	                   
                      </form>               
                    </div>
                    <div className="modal-footer">
                      <div>
                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">
                          Cancel
                        </button>
                        <button type="button" onClick={(e) => this.editArrivalDate(e)} className="btn btn-primary m-btn--pill">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* end arrival date edit */}
              {/* Web visibility modal start */}
              <div
                className="modal fade"
                id="woo_page_status_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Current Status
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="my-3">
                        <input type="radio" id="privateWooPageStatus" name="privateWooPageStatus" value={this.wooPageStatusOptions.Private} onChange={this.changeWooPageStatusOption} checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Private} />
                        <label htmlFor="privateWooPageStatus" className="ml-2 mb-0">Hidden</label>
                        {
                          this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Private ? 
                          <div className="m-radio-inline">
                            <label className="m-radio mb-0 ml-3 mt-2">
                                <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Available } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Available} /> {" "}Available
                                <span></span>
                            </label>
                            <label className="m-radio mb-0 ml-3 mt-2">
                                <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Sold} /> {" "}Sold
                                <span></span>
                            </label>
                            {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                              <>
                                <select className="form-select" onChange={this.handleChangeOption} name="soldReason" value={soldReason}>
                                  <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                                  {soldReasonValues.map( row => {
                                    return <option value={row.key} selected={soldReason === row.key ? true : false}>{row.value}</option>
                                  })
                                  }
                                </select>
                                <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                              </>
                              :
                              ""
                            }
                          </div>
                          : ""
                        }
                      </div>
                      <div className="my-3">
                        <input type="radio" id="publicWooPageStatus" name="publicWooPageStatus" value={this.wooPageStatusOptions.Public} onChange={this.changeWooPageStatusOption} checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Public} />
                        <label for="publicWooPageStatus" className="ml-2 mb-0">Visible</label>
                        {
                          this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Public ? 
                          <div className="m-radio-inline">
                              <label className="m-radio mb-0 ml-3 mt-2">
                                  <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Available } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Available} /> {" "}Available
                                  <span></span>
                              </label>
                              <label className="m-radio mb-0 ml-3 mt-2">
                                  <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Sold} /> {" "}Sold
                                  <span></span>
                              </label>
                              {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                              <>
                                <select className="form-select" onChange={this.handleChangeOption} name="soldReason" value={soldReason}>
                                  <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                                  {soldReasonValues.map( row => {
                                    return <option value={row.key} selected={soldReason === row.key ? true : false}>{row.value}</option>
                                  })
                                  }
                                </select>
                                <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                              </>
                              :
                              ""
                            }
                          </div>
                          : ""
                        }
                      </div>
                      <div className="my-3">
                        <input type="radio" id="financeWooPageStatus" name="financeWooPageStatus" value={this.wooPageStatusOptions.Finance} onChange={this.changeWooPageStatusOption} checked={this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Finance} />
                        <label for="financeWooPageStatus" className="ml-2 mb-0">Private Link</label>
                        {
                          this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Finance ? 
                          <div className="m-radio-inline">
                            <label className="m-radio mb-0 ml-3 mt-2">
                                <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Available } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Available} /> {" "}Available
                                <span></span>
                            </label>
                            <label className="m-radio mb-0 ml-3 mt-2">
                                <input type="radio" name="petAvailability" checked={this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold } onChange={this.changeWooPagePuppyStatusOption} value={this.wooPagePuppyStatusOptions.Sold} /> {" "}Sold
                                <span></span>
                            </label>
                            {this.state.selectedWooPagePuppyStatusOption === this.wooPagePuppyStatusOptions.Sold ? 
                              <>
                                <select className="form-select" onChange={this.handleChangeOption} name="soldReason" value={soldReason}>
                                  <option hidden value={null} style={{display: "none"}}>Select Reason</option>
                                  {soldReasonValues.map( row => {
                                    return <option value={row.key} selected={soldReason === row.key ? true : false}>{row.value}</option>
                                  })
                                  }
                                </select>
                                <span className="invalid-feedback" style={{display: this.state.customFormNotValid ? "block": "none"}}>Please select reason.</span>
                              </>
                              :
                              ""
                            }
                          </div>
                          : ""
                        }
                      </div>
                    { 
                    this.state.selectedMedicalRecord && this.state.selectedMedicalRecord.woo_page_status === this.wooPageStatusOptions.Finance && this.state.selectedWooPageStatusOption === this.wooPageStatusOptions.Finance ?   
                      <div>        
                        <div className="mb-2">
                          <span className="m-widget4__sub">
                            <i className="la la-link mr-2"></i>
                            <span>
                              <strong>Link: </strong>
                            </span>
                          </span>
                        </div>

                        <div className="row  justify-content-end mt-4">

                          <div className="col-md-10 pr-0">
                            <div className="m-widget4__ext">
                            <input
                                type="text"
                                name="woo_permalink"
                                onChange={this.changeVal}
                                className="form-control m-input"
                                placeholder=""
                                disabled={true}        
                                value={this.state.selectedMedicalRecord.woo_permalink}
                              />
                            </div>
                          </div>

                          <div className="col-md-2">
                            <div className="m-widget4__ext">
                              <button
                                type="button"
                                onClick={() => this.copyWooPageUrl()}
                                className="btn btn-primary m-btn--pill"
                              >
                                Copy
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                      : ""
                    }

                    </div>

                    <div className="modal-footer">
                    {this.state.loadingWooPageStatus == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Close
                          </button>
                          {soldReason && soldReasonValues.find(record => (record.key === soldReason && record.notify === true) && this.state.availableSubscribers.length > 0 && this.state.selectedMedicalRecord.Contract === null) ? 
                            <button
                              type="button"
                              onClick={() => this.changeStateOfSoldPopUp()}
                              className="btn btn-primary m-btn--pill"
                              >
                              Update
                            </button>
                            :
                            <button
                              type="button"
                              onClick={() => this.setWooPageStatus()}
                              className="btn btn-primary m-btn--pill"
                              >
                              Update
                            </button>
                          }
                          
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                       )}
                    </div>
                  </div>
                </div>
              </div> 
              {/* Web visibility modal end */}

               {/* Notification modal start */}
               <div
                className="modal fade"
                id="send_notification_model"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Confirm to send notifications
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={e => this.cancelProcess()}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                      Do you want to notify subscribers of these changes?
                      </p>
                    </div>
                    <div className="modal-footer">
                      {!this.state.loadingWooPageStatus? (
                        <div>                    
                          { this.state.soldReason && soldReasonValues.find(record => (record.key === this.state.soldReason && record.notify === true))  ? 
                            <div>
                              <button
                                type="button"
                                className="btn btn-secondary m-btn--pill mx-2"
                                onClick={() => this.setWooPageStatus(false)}
                              >
                                No
                              </button>
                              <button
                                type="button"
                                onClick={() => this.setWooPageStatus(true)}
                                className="btn btn-primary m-btn--pill"
                              >
                                Yes
                              </button>
                            </div> 
                          : ""}
                          
                        </div>
                      ) : (
                          <div className="center-row">
                            <Loader size={50} />
                          </div>
                        )}
                    </div>
                  </div>
                </div>
             </div>
            {/* Notification modal end */}   
            </div>
          </div>
        </div>
        <ChangeArrivalDate updatedArrivalDate = {this.updatedMedicalRecordList}/>
        {this.state.clickedId ? <MRecordPDF setClick={this.acceptMethods.bind(this)} unmountMe={this.handleChildUnmount.bind(this)} /> : null}
        {this.state.clickedIdDoPdf ? <DoPdf type={this.state.type} setClick={this.acceptMethodsForPdf.bind(this)} envelope={this.state.envelope} waybill={this.state.waybill} medical_record={this.state.medical_record} unmountMe={this.handleChildUnmountDoPdf.bind(this)} /> : null}
        {this.state.clickedIdCollarInsert ? <CollerInsert type={this.state.type} breederData={this.state.breederMRData} setClick={this.acceptMethodsForCollarInsertPdf.bind(this)}  unmountMe={this.handleChildUnmountCollarInsertPdf.bind(this)} /> : null}

      </div>
    );
  }
}

export const Mobile = (props) => <Responsive {...props} maxWidth={767} />;
export const Default = (props) => <Responsive {...props} minWidth={768} />;

const mapStateToProps = state => ({
  data: state,
  toa: state.addAnimalTypeReducer.animalTypes,
  reg_types: state.regTypeReducer.regTypes,
  toaError: state.addAnimalTypeReducer.animalTypesError,
  reg_types_error: state.regTypeReducer.regTypesError,
  mRecordsError: state.medicalRecordsReducer.mRecordsError,
  pdfStatus: state.medicalRecordsReducer.pdfStatus,
  breeders: state.breederReducer.breederList,
  updatedMultipleRecords : state.medicalRecordsReducer.updatedMultipleRecords,
  pinToTopQueue : state.medicalRecordsReducer.pinToTopQueue,
  pinToTopQueueError : state.medicalRecordsReducer.pinToTopQueueError,

});

const mapDispatchToProps = dispatch => ({
  fetchMedicalRecords: () => {
    dispatch(fetchMedicalRecords());
  },
  fetchAnimalTypes: () => {
    dispatch(fetchAnimalTypes());
  },
  fetchRegTypes: () => {
    dispatch(fetchRegTypes());
  },
  fetchBreeders: () => {
    dispatch(fetchBreeders());
  },
  deleteMRecords: selected => {
    dispatch(getDeletable(selected));
  },
  updatePrintMRecord: id => {
    dispatch(updatePrintMRecord(id));
  },
  fetchBreederDeliveryRecords: (sdate, edate) => {
    dispatch(fetchBreederDeliveryRecords(sdate, edate));
  },
  fetchBreederDeliveryRecordsByBreederId: (id, sdate, edate) => {
    dispatch(fetchBreederDeliveryRecordsByBreederId(id, sdate, edate));
  },
  fetchWaybillsForAllPets: (id, sdate, edate) => {
    dispatch(fetchWaybillsForAllPets(id, sdate, edate));
  },
  updateMedicalRecord: (id, data) => {
    dispatch(updateMedicalRecord(id, data));
  },  
  boostWooStoreProfile: (id) => {
    dispatch(boostWooStoreProfile(id));
  },
  getNotificationsByMedicalRecord: id => {
    dispatch(getNotificationsByMedicalRecord(id));
  },
  updateVideoCallStatus: (id, data) => {
    dispatch(updateVideoCallStatus(id, data));
  },
  updateWooPageStatus: (id, data) => {
    dispatch(updateWooPageStatus(id, data));
  },
  petPinToTop: (id,status)=> {
    dispatch(petPinToTop(id,status));
  },
  fetchMedicalRecordsByAge: (age_limit) => {
    dispatch(fetchMedicalRecordsByAge(age_limit));
  }

});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);

